import { render, staticRenderFns } from "./PricesListContenty.vue?vue&type=template&id=b984206e&scoped=true"
import script from "./PricesListContenty.vue?vue&type=script&lang=js"
export * from "./PricesListContenty.vue?vue&type=script&lang=js"
import style0 from "./PricesListContenty.vue?vue&type=style&index=0&id=b984206e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b984206e",
  null
  
)

export default component.exports